import * as React from 'react';
import { SVGProps } from 'react';

export const FlatPack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.558 28.3905C19.5409 28.3905 18.7188 27.563 18.7188 26.5512C18.7188 26.4141 18.8294 26.3035 18.9664 26.3035C19.1035 26.3035 19.2141 26.4141 19.2141 26.5512C19.2141 27.2943 19.8202 27.9003 20.5633 27.9003C21.3064 27.9003 21.9125 27.2943 21.9125 26.5512C21.9125 26.4141 22.0232 26.3035 22.1602 26.3035C22.2972 26.3035 22.4079 26.4141 22.4079 26.5512C22.4079 27.5683 21.5805 28.3905 20.5686 28.3905H20.558Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M22.1549 26.7461C22.1496 26.7514 21.9072 26.6354 21.9072 26.4984V11.1727C21.9072 11.0778 21.9599 10.9935 22.0495 10.9513C23.2616 10.3769 24.0469 9.1384 24.0469 7.79978C24.0469 6.46115 23.2352 5.18049 21.9915 4.62185V7.56262C21.9915 7.65221 21.944 7.73126 21.865 7.77869L20.6634 8.46382C20.5896 8.50598 20.4947 8.50598 20.4157 8.46382L19.2404 7.77869C19.1667 7.73653 19.1192 7.65221 19.1192 7.56789V4.62185C17.8755 5.18049 17.0639 6.41899 17.0639 7.79978C17.0639 9.18056 17.8491 10.3716 19.0613 10.9513C19.1456 10.9935 19.2036 11.0778 19.2036 11.1727V26.4984C19.2036 26.6354 19.0929 26.7461 18.9559 26.7461C18.8188 26.7461 18.7082 26.6354 18.7082 26.4984V11.3255C17.4064 10.6404 16.5737 9.27543 16.5737 7.79978C16.5737 6.08697 17.6647 4.57442 19.2879 4.02632C19.3617 3.99997 19.446 4.01578 19.5092 4.05794C19.5725 4.10538 19.6094 4.17916 19.6094 4.25821V7.42032L20.5422 7.96315L21.4961 7.42032V4.25821C21.4961 4.17916 21.533 4.10538 21.5962 4.05794C21.6595 4.01051 21.7438 3.99997 21.8176 4.02632C23.4408 4.57442 24.5317 6.08697 24.5317 7.79978C24.5317 9.27543 23.699 10.6404 22.3973 11.3255V26.5037C22.3973 26.6407 22.1496 26.7514 22.1496 26.7514L22.1549 26.7461Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M10.2023 26.4036L9.95459 26.1559V16.5062C9.95459 16.4535 9.9704 16.4008 10.002 16.3586L11.2511 14.7143C11.3301 14.6036 11.4882 14.5826 11.5936 14.6669C11.7043 14.7512 11.7254 14.904 11.641 15.0095L10.4447 16.5905V26.1612L10.2023 26.4036Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M14.0441 26.4194C14.0388 26.4141 13.7964 26.3087 13.7964 26.1717V16.58L12.6422 14.9989C12.5632 14.8883 12.5842 14.7354 12.6949 14.6564C12.8056 14.5773 12.9584 14.5984 13.0375 14.7091L14.2391 16.3534C14.2707 16.3955 14.2865 16.4482 14.2865 16.4957V26.1664C14.2865 26.3035 14.0441 26.4194 14.0388 26.4141L14.0441 26.4194Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M12.8429 15.2202H11.4358C11.2987 15.2202 11.1881 15.1095 11.1881 14.9725V7.47832L10.5451 6.50861C10.5029 6.44537 10.4924 6.36631 10.5135 6.2978L11.1986 4.16865C11.2302 4.06851 11.3251 4 11.4305 4H12.8376C12.943 4 13.0379 4.06851 13.0695 4.16865L13.7546 6.2978C13.7757 6.37158 13.7652 6.44537 13.723 6.50861L13.08 7.47832V14.9725C13.08 15.1095 12.9694 15.2202 12.8324 15.2202H12.8429ZM11.6835 14.7301H12.6005V7.40454C12.6005 7.35711 12.6163 7.30968 12.6426 7.26751L13.2645 6.33469L12.669 4.49013H11.6202L11.0247 6.33469L11.6466 7.26751C11.6729 7.30968 11.6887 7.35711 11.6887 7.40454V14.7301H11.6835Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M13.9547 16.7593H11.952C11.8519 16.7593 11.7676 16.675 11.7676 16.5748C11.7676 16.4747 11.8519 16.3904 11.952 16.3904H13.9547C14.0548 16.3904 14.1392 16.4747 14.1392 16.5748C14.1392 16.675 14.0548 16.7593 13.9547 16.7593Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M12.1261 28.3955C10.935 28.3955 9.96533 27.4258 9.96533 26.2348C9.96533 26.0977 10.076 25.9871 10.213 25.9871C10.3501 25.9871 10.4607 26.0977 10.4607 26.2348C10.4607 27.157 11.2091 27.9054 12.1314 27.9054C13.0537 27.9054 13.802 27.157 13.802 26.2348C13.802 26.0977 13.9127 25.9871 14.0497 25.9871C14.1867 25.9871 14.2974 26.0977 14.2974 26.2348C14.2974 27.4258 13.3277 28.3955 12.1366 28.3955H12.1261Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M17.4539 13.0911H14.3234C14.1864 13.0911 14.0757 12.9804 14.0757 12.8434C14.0757 12.7064 14.1864 12.5957 14.3234 12.5957H17.4539C17.5909 12.5957 17.7016 12.7064 17.7016 12.8434C17.7016 12.9804 17.5909 13.0911 17.4539 13.0911Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M8.78492 16.8117H1.83882C1.73869 16.8117 1.64909 16.7538 1.6122 16.6589C1.57531 16.5693 1.59639 16.4639 1.6649 16.3901L5.37511 12.6641C5.42254 12.6167 5.48579 12.5903 5.54903 12.5903H9.93382C10.0708 12.5903 10.1815 12.7063 10.1815 12.8433C10.1815 12.9803 10.0708 13.091 9.93382 13.091H5.64916L2.42908 16.3216H8.78492C8.92194 16.3216 9.03262 16.4323 9.03262 16.5693C9.03262 16.7063 8.92194 16.817 8.78492 16.817V16.8117Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M31.1982 16.8119H23.6935C23.5565 16.8119 23.4458 16.7012 23.4458 16.5642C23.4458 16.4272 23.5565 16.3165 23.6935 16.3165H30.608L27.3879 13.0806H23.6988C23.5617 13.0806 23.4511 12.9699 23.4511 12.8329C23.4511 12.6959 23.5617 12.5852 23.6988 12.5852H27.4933C27.5565 12.5852 27.6198 12.6116 27.6672 12.659L31.3774 16.385C31.4459 16.4535 31.467 16.5589 31.4301 16.6538C31.3932 16.7434 31.3036 16.8066 31.2035 16.8066L31.1982 16.8119Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M8.7843 20.601H1.79604C1.65901 20.601 1.54834 20.4904 1.54834 20.3533V16.601C1.54834 16.4639 1.65901 16.3533 1.79604 16.3533C1.93306 16.3533 2.04374 16.4639 2.04374 16.601V20.1056H8.78957C8.9266 20.1056 9.03727 20.2163 9.03727 20.3533C9.03727 20.4904 8.9266 20.601 8.78957 20.601H8.7843Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M31.1982 20.601H23.6935C23.5565 20.601 23.4458 20.4904 23.4458 20.3533C23.4458 20.2163 23.5565 20.1056 23.6935 20.1056H30.9558V16.601C30.9558 16.4639 31.0665 16.3533 31.2035 16.3533C31.3405 16.3533 31.4512 16.4639 31.4512 16.601V20.3533C31.4512 20.4904 31.3405 20.601 31.2035 20.601H31.1982Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M17.4541 16.7962H15.5831C15.4461 16.7962 15.3354 16.6855 15.3354 16.5485C15.3354 16.4115 15.4461 16.3008 15.5831 16.3008H17.4541C17.5911 16.3008 17.7018 16.4115 17.7018 16.5485C17.7018 16.6855 17.5911 16.7962 17.4541 16.7962Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
    <path
      d="M17.4541 20.6065H15.5831C15.4461 20.6065 15.3354 20.4958 15.3354 20.3588C15.3354 20.2218 15.4461 20.1111 15.5831 20.1111H17.4541C17.5911 20.1111 17.7018 20.2218 17.7018 20.3588C17.7018 20.4958 17.5911 20.6065 17.4541 20.6065Z"
      fill="#071114"
      stroke="#071114"
      strokeWidth="0.7"
    />
  </svg>
);
export default FlatPack;
